var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcLogo = function SvgIcLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.171 6.963a.588.588 0 0 0-.344.11l-4.905 3.535a.577.577 0 0 0-.213.65l1.874 5.417c.078.24.302.4.556.4h6.064a.584.584 0 0 0 .557-.4l1.874-5.417a.577.577 0 0 0-.213-.65l-4.905-3.534a.588.588 0 0 0-.345-.111Zm3.27 13.609h-6.54a3.779 3.779 0 0 1-3.607-2.59l-2.021-5.846a3.714 3.714 0 0 1 1.377-4.19l5.292-3.8a3.82 3.82 0 0 1 4.459 0l5.291 3.8a3.714 3.714 0 0 1 1.378 4.19l-2.021 5.846a3.78 3.78 0 0 1-3.607 2.59Z",
    fill: "currentColor"
  })));
};
export default SvgIcLogo;